import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateInProgress = (quantity: IQuantity, actions: any, selectedOrder?: any) => {
  const items = [{
    key: "delete",
    text: "Anuluj zamówienie",
    iconProps: { iconName: "delete" },
    name: "delete",
    onClick: actions.setOrderCanceled,
  },
  {
    key: "restore",
    text: "Przywróć do przyjętych",
    iconProps: { iconName: "Back" },
    name: "restore",
    onClick: actions.setOrderAccepted,
  },
  {
    key: "sms",
    text: "SMS do kierowcy",
    iconProps: { iconName: "Message" },
    name: "sms",
    onClick: actions.sendSMS,
  },]

  const cuoSplitsButton = selectedOrder && selectedOrder.isFromCuo === "CUO" ? [{
    key: "cuoSplits",
    text: "Zarządzaj rozbiciami",
    iconProps: { iconName: "BranchMerge" },
    name: "cuoSplits",
    onClick: actions.openCuoSplitsPanel,
  }] : [];

  switch (quantity) {
    case Quantity.NONE:
      return [];
    case Quantity.ONE:
      return [
        {
          key: "see",
          text: "Zobacz",
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanelToSee,
        },
        {
          key: "edit",
          text: "Zakończ",
          iconProps: { iconName: "edit" },
          onClick: actions.openPanel,
        },
        ...cuoSplitsButton,
        ...items
      ];
    case Quantity.MANY:
      return [...items];
  }
};
